import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nhip-home-pdf',
  templateUrl: './nhip-home-pdf.component.html',
  styleUrls: ['./nhip-home-pdf.component.scss']
})
export class NhipHomePdfComponent implements OnInit {
  // processedCycloneDataForPdf: any;
  // earthquakeDataForPdf: any
  // mapImage:any
  infoComp:any
  currentDate: string;
  largestMagnitude: any;
  selectedTimeRange: any;

  isPointQuery: boolean = false;
  showEarthquake: boolean = true;
  showCyclone: boolean = true;
  reportTitle: string = 'NHIP Report';
  fileName: string = 'NHIP Report.pdf';

  facilityIcons: { [key: string]: string } = {
    nearestSchool: 'fas fa-school',
    nearestHealthcare: 'fas fa-hospital',
    nearestAirport: 'fas fa-plane',
    nearestRailway: 'fas fa-train',
    nearestNH: 'fas fa-road'
  };

  constructor() {
   }

  ngOnInit() {
    this.currentDate = this.getCurrentDate()
    this.isPointQuery = !!this.infoComp.isPointQuery;

    if (this.isPointQuery) {
      this.reportTitle = 'NHIP Point Hazard Report';
      const coords = this.infoComp.selectedLat != null && this.infoComp.selectedLng != null
        ? `${this.infoComp.selectedLat.toFixed(4)},${this.infoComp.selectedLng.toFixed(4)}`
        : '';
      this.fileName = `NHIP Point Report${coords ? ' - ' + coords : ''}.pdf`;
      return;
    }

    // Area report: only include the sections for the selected hazard type
    const hazardView = this.infoComp.queryParams && this.infoComp.queryParams.params
      ? this.infoComp.queryParams.params.hazardView : 'multiHazard';
    this.showEarthquake = hazardView === 'earthquake' || hazardView === 'multiHazard';
    this.showCyclone = hazardView === 'cyclone' || hazardView === 'multiHazard';

    const hazardTitles = { earthquake: 'Earthquake', cyclone: 'Cyclone', multiHazard: 'Multi-Hazard' };
    this.reportTitle = `NHIP ${hazardTitles[hazardView] || ''} Report`.replace('  ', ' ');
    this.fileName = `${this.reportTitle} - ${this.infoComp.headerConfig.location}.pdf`;

    let yearRange = this.infoComp.selectedTimeRange.split(' ')[1]
    let currentYear = this.currentDate.split('/')[2]
    this.selectedTimeRange = this.infoComp.selectedTimeRange == 'All Historical' ? 'Since 1980' : Number(currentYear) - yearRange + '-' + currentYear

    // [1] is the highest-intensity row; fall back to the only row when there is just one
    const eqRows = this.infoComp.earthquakeDataForPdf || [];
    const largest = eqRows[1] || eqRows[0];
    this.largestMagnitude = largest ? largest['magnitude'] + 'M' : '-'
  }

  getCurrentDate(): string {
  const today = new Date();

  const day = String(today.getDate()).padStart(2, '0');
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const year = today.getFullYear();

  return `${day}/${month}/${year}`;
}

}
